import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { Store } from '@ngrx/store/index';
import { ProductCategoriesState } from './product-categories.store';
import { ProductCategoriesActions } from './product-categories.actions';

import { DragulaService } from 'ng2-dragula/index';

import { ConfigService } from '../config/config.service';
import { ProductCategory } from '../product-categories/product-category';
import { ProductCategoriesService } from '../product-categories/product-categories.service';
import { LoggingService } from '../loging/logging.service';
export class ProductCategoriesEditorComponent implements OnInit {
private config: any;
    productCategories: Observable<ProductCategory[]>;
    productCategoriesModel: ProductCategory[];
    productCategoryImagesUrl: string;
/**
 * @param {?} router
 * @param {?} configService
 * @param {?} productCategoriesService
 * @param {?} location
 * @param {?} dragulaService
 * @param {?} store
 * @param {?} productCategoriesActions
 * @param {?} loggingService
 */
constructor(
private router: Router,
private configService: ConfigService,
private productCategoriesService: ProductCategoriesService,
private location: Location,
private dragulaService: DragulaService,
private store: Store<ProductCategoriesState>,
private productCategoriesActions: ProductCategoriesActions,
private loggingService: LoggingService
    ) {
        this.productCategories = store.select('productCategories');

        this.productCategories.subscribe(
            (productCategories: ProductCategory[]) => {
                this.productCategoriesModel = productCategories;
            }
        )


        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.productCategoryImagesUrl = this.config.awsBucket + 'img/product-categories/';
        });

        dragulaService.setOptions('first-bag', {});

        dragulaService.dropModel.subscribe(
            this.onProductCategoryDropModel
        );


    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.loggingService.log('ProductImageListComponent:ngOnInit()');
    }
/**
 * @param {?} productCategory
 * @return {?}
 */
addProductCategory(productCategory: string): void {
        let /** @type {?} */ newCategoryName = window.prompt("Enter a new Product Category");
        let /** @type {?} */ newProductCategory: ProductCategory = {
            _id: null,
            Key:newCategoryName,
            DisplayIndex: null,
            ImageUrl: ""
        };

        this.store.dispatch(this.productCategoriesActions.addProductCategory(newProductCategory));
    }

    onProductCategoryDropModel = (value: any) => {
        this.loggingService.log('this.productCategoriesModel = ');
        this.loggingService.log(this.productCategoriesModel);

        let /** @type {?} */ productCategory = value[1].title;

        for (let /** @type {?} */ i = 1; i < this.productCategoriesModel.length; i++) {
            if(this.productCategoriesModel[i-1].Key == productCategory){

                this.store.dispatch(
                    this.productCategoriesActions.moveProductCategoryTo(productCategory, i)
                )

            }
        }
    }
/**
 * @param {?} productCategoryName
 * @return {?}
 */
deleteProductCategory(productCategoryName: string): void {
        this.store.dispatch(this.productCategoriesActions.deleteProductCategory(productCategoryName));
    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @param {?} productCategory
 * @return {?}
 */
addProductCategoryImage(productCategory: ProductCategory): void {
        let /** @type {?} */ addProductCategoryImageInputElement: any = document.getElementById("addProductCategoryImageInput");
        addProductCategoryImageInputElement.style.visibility = "visible";
        addProductCategoryImageInputElement.productCategory = productCategory;

        addProductCategoryImageInputElement.click();
    }
/**
 * @return {?}
 */
productCategoryImageAdded(): void {
        let /** @type {?} */ addProductCategoryImageInputElement: any = document.getElementById("addProductCategoryImageInput");
        let /** @type {?} */ file = addProductCategoryImageInputElement.files[0];
        let /** @type {?} */ productCategory = addProductCategoryImageInputElement.productCategory;
        let /** @type {?} */ fileName = productCategory.Key;

        this.store.dispatch(this.productCategoriesActions.getProductCategoryImageSignature(productCategory, file, fileName));
        
        addProductCategoryImageInputElement.style.visibility = "hidden";
    }
/**
 * @param {?} file
 * @param {?} signed_request
 * @param {?} url
 * @param {?} done
 * @return {?}
 */
upload(file: any, signed_request: string, url: string, done: any) {
        let /** @type {?} */ xhr = new XMLHttpRequest();
        xhr.open("PUT", signed_request);
        xhr.setRequestHeader('x-amz-acl', 'public-read');
        xhr.onload = () => {
            if (xhr.status === 200) {
                done(url, this);
            } else if (xhr.status === 403) {
                // this.delete(file, signed_request, url, done);
            }
        }
        xhr.send(file);
    }
/**
 * @param {?} url
 * @param {?} thisObject
 * @return {?}
 */
afterFileUpload(url: string, thisObject: any): void {
        this.loggingService.log(url);
        thisObject.getProductImages();
        thisObject.location.replaceState(window.location.href);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-product-categories-editor',
    template: "<div> <div *ngIf=\"(productCategories | async).length > 0\" class='container' [dragula]='\"first-bag\"' [dragulaModel]=\"productCategoriesModel\"> <div *ngFor=\"let productCategory of (productCategories | async)\" class=\"row col-xs-12 product-category-div\" title=\"{{productCategory.Key}}\"> <span class=\"product-category-name\">{{productCategory.Key}}&nbsp;&nbsp;</span> <img class=\"product-category-image\" src=\"{{productCategory.ImageUrl}}\" alt=\"add image\" (click)=\"addProductCategoryImage(productCategory)\" /> <span class=\"glyphicon glyphicon-trash\" (click)=\"deleteProductCategory(productCategory.Key)\"></span> </div> </div> <div *ngIf=\"(productCategories | async).length == 0\"> No Product Categories </div> <button class=\"add-new-category-button\" (click)=\"addProductCategory()\">Add Product Category</button> <button (click)=\"goBack()\">Back</button> <input style=\"visibility:hidden\" type=\"file\" class=\"add-product-category-image-input-button\" id=\"addProductCategoryImageInput\" (change)=\"productCategoryImageAdded()\" value=\"Add Image\" /> </div>",
    styles: [".product-category-image{ height: 2em; }",
".gu-mirror { position: fixed !important; margin: 0 !important; z-index: 9999 !important; opacity: 0.8; -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\"; filter: alpha(opacity=80); } .gu-hide { display: none !important; } .gu-unselectable { -webkit-user-select: none !important; -moz-user-select: none !important; -ms-user-select: none !important; user-select: none !important; } .gu-transit { opacity: 0.2; -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\"; filter: alpha(opacity=20); } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: ConfigService, },
{type: ProductCategoriesService, },
{type: Location, },
{type: DragulaService, },
{type: Store, },
{type: ProductCategoriesActions, },
{type: LoggingService, },
];
}

function ProductCategoriesEditorComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductCategoriesEditorComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductCategoriesEditorComponent.ctorParameters;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.config;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.productCategories;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.productCategoriesModel;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.productCategoryImagesUrl;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.onProductCategoryDropModel;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.router;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.configService;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.productCategoriesService;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.location;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.dragulaService;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.store;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.productCategoriesActions;
/** @type {?} */
ProductCategoriesEditorComponent.prototype.loggingService;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
